import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getGpsDevicesRequest, setStateGps, setGpsSelected } from '../../actions/gps';
import { setGpsFilters } from '../../actions/filters';
import { gpsSelector } from '../../selectors/gps';
import { filtersGpsToUseInQuerySelector } from '../../selectors/filters';
import GpsLoader from './GpsLoader';

const mapStateToProps = createStructuredSelector({
    gps: gpsSelector,
    filtersoUseInQuery: filtersGpsToUseInQuerySelector
});
const mapDispatchToProps = {
    getGpsDevicesRequest,
    setStateGps,
    setGpsSelected,
    setGpsFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(GpsLoader);
